module.exports = __webpack_public_path__ + "Tele2TextSans-Bold.3189cd6e.woff";


//////////////////
// WEBPACK FOOTER
// /var/www/build-health-2/src/assets/fonts/bold/Tele2TextSans-Bold.woff
// module id = 2381
// module chunks = 0